import type { RouteRecordRaw } from 'vue-router';

/**
 * Authentication Routes
 *
 * Routes for user authentication including login, register,
 * password reset, email verification, and profile management.
 */

const authRoutes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/auth/LoginView.vue'),
    meta: {
      requiresAuth: false,
      title: 'Sign In',
    },
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/auth/RegisterView.vue'),
    meta: {
      requiresAuth: false,
      title: 'Create Account',
    },
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('@/views/auth/ForgotPasswordView.vue'),
    meta: {
      requiresAuth: false,
      title: 'Forgot Password',
    },
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: () => import('@/views/auth/ResetPasswordView.vue'),
    meta: {
      requiresAuth: false,
      title: 'Reset Password',
    },
  },
  {
    path: '/verify-email',
    name: 'verify-email',
    component: () => import('@/views/auth/VerifyEmailView.vue'),
    meta: {
      requiresAuth: false,
      title: 'Verify Email',
    },
  },
  {
    path: '/settings/profile',
    name: 'profile-settings',
    component: () => import('@/views/auth/ProfileView.vue'),
    meta: {
      requiresAuth: true,
      title: 'Profile Settings',
    },
  },
];

export default authRoutes;
